import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { DeviceData } from '@devices';
import { firstValueFrom as toPromise, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InventoryService {
  private http = inject(HttpClient);
  private serviceUrl = `devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/inventory`;

  registerDevice(payload: {
    locationId: string;
    serialNumber: string;
    spaceId: string;
  }) {
    return toPromise(
      this.http.post<{ data: DeviceData; }>(`${this.serviceUrl}/register`, payload)
        .pipe(map(({ data }) => data)),
    );
  }
}
